///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables = abcsetup.datatables || {};
abcsetup.datatables.search = abcsetup.datatables.search || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Global Initialize
//
///////////////////////////////////////////////////////////////////////////////////////////////////
$(function () {
    // The search button was clicked
    $(document).on('mousedown', '.btn-column-search', function() {
        abcsetup.datatables.search.button = $(this);
    });

    // The column search modal is about to show
    $("#column-search-modal").on("show.bs.modal", function() {
        abcsetup.datatables.search.table = abcsetup.datatables.search.button.closest('.dataTables_wrapper').find('.dataTable');
        abcsetup.datatables.search.dtTable = abcsetup.datatables.search.table.DataTable();

        // We have scrollX turned on
        if (abcsetup.datatables.search.table.closest('.dataTables_scroll').length) {
            abcsetup.datatables.search.dtTable = abcsetup.datatables.search.table.closest('.dataTables_scroll').find('.dataTables_scrollBody table.datatable').DataTable();
        }

        abcsetup.datatables.search.showFilter();
        abcsetup.select2.init();
    });

    // The column search modal has shown
    $("#column-search-modal").on("shown.bs.modal", function() {
        $('#column-search-modal .modal-body').find('input, select').first().focus();

        let statusTab = window.location.pathname;
        let datePickerOptions = {
            parentEl: "#column-search-modal",
            //timePicker: $(this).attr('type') == 'datetime', // TODO: enable support for datetime pickers
            autoUpdateInput: false,
            alwaysShowCalendars: true,
            minDate: location.pathname == '/email_queue/recent' ? moment().subtract(120, 'days') : null,
            maxDate: moment().add(10, 'years'),
            "cancelClass": "btn-secondary",
            showDropdowns: true,
            locale: {
                cancelLabel: 'Clear',
                format: 'MM/DD/YYYY',
            },
            ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
        };


        if (statusTab == '/email_queue/recent') {
            datePickerOptions.minDate = moment().subtract(120, 'days');
        }

        // Apply the daterangepicker to any datetime columns
        $('#column-search-modal input[type="datetime"], #column-search-modal input.date').attr('readonly', true);
        $('#column-search-modal input[type="datetime"], #column-search-modal input.date').daterangepicker(datePickerOptions)
            .on('apply.daterangepicker', function(ev, picker) {
                $(this).val(picker.startDate.format('MM/DD/YYYY') + ' - ' + picker.endDate.format('MM/DD/YYYY'));
            })

            .on('cancel.daterangepicker', function() {
                $(this).val('');
            });
    });

    // The apply search button was clicked from the modal
    $(document).on('click', '#column-search-modal .confirm', function() {
        // Apply any filters that the user put in the modal
        abcsetup.datatables.search.applyFilter();
    });

    // The reset search button was clicked from the modal
    $(document).on('click', '#column-search-modal .reset', function() {
        // Reset any filtering that has been applied
        abcsetup.datatables.search.resetFilter();
    });

    // The reset filter link was clicked
    $(document).on('click', '.reset-column-search', function() {
        abcsetup.datatables.search.table = $(this).closest('.dataTables_wrapper').find('.dataTable');
        abcsetup.datatables.search.dtTable = abcsetup.datatables.search.table.DataTable();

        // We have scrollX turned on
        if (abcsetup.datatables.search.table.closest('.dataTables_scroll').length) {
            abcsetup.datatables.search.dtTable = abcsetup.datatables.search.table.closest('.dataTables_scroll').find('.dataTables_scrollBody table.datatable').DataTable();
        }

        // Reset any filtering that has been applied
        abcsetup.datatables.search.resetFilter();
    });

    // A search field had a key pressed
    $(document).on('keyup', '#column-search-modal .modal-body input, #column-search-modal .modal-body select', function(e) {
        if (e.which == 13) {
            $('#column-search-modal .confirm').trigger('click');
        }
    });
});



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.datatables.search = {
    table: null,
    dtTable: null,
    button: null,
    columnSettings: null,

    /**
     * Apply the column filtering
     *
     * @param {*} table
     */
    init: function(table) {
        table.closest('.dataTables_wrapper')
            .find('.dt-buttons')
            .after('<button type="button" class="btn btn-info btn-sm btn-column-search ml-2" data-toggle="modal" data-target="#column-search-modal"><i class="fas fa-search"></i> Search</button>');

        // Apply any filters specified in the request string
        this.applyRequestFilters(table);

        // Handle the draw back event from the table
        this.drawBack(table);
    },

    /**
     * Show the column filter modal
     */
    showFilter: function()
    {
        abcsetup.datatables.search.columnSettings = abcsetup.datatables.search.dtTable.settings().init().columns;

        // Ensure the searchable attribute
        $(abcsetup.datatables.search.columnSettings).each(function(key) {
            if (typeof this.searchable === 'undefined') {
                this.searchable = !abcsetup.datatables.search.table.find('thead').first().find('th').eq(key).is('.sorting_disabled, .noFilter');
                this.title = abcsetup.datatables.search.dtTable.column(key).header().innerHTML;
            }

            // Set up the field type based on the datatable or just default to text
            this.type = this.type ?? 'text';
        });

        $('#column-search-modal .modal-body table').html('');

        $(abcsetup.datatables.search.columnSettings).each(function(key, col) {
            if (col.searchable) {
                let val = abcsetup.datatables.search.dtTable.column(key).search();
                let field = '';
                let className = col.className ?? '';

                if (col.type == 'select') {
                    if (className.indexOf('select2') > -1) {
                        field = '<select class="form-control select2 w-100" multiple>';
                    } else if (className.indexOf('multiple') > -1) {
                        field = '<select class="form-control" multiple>';
                    } else {
                        field = '<select class="form-control"><option value=""></option>';
                    }

                    $(col.options).each(function() {
                        field = field + '<option value="' + Object.keys(this)[0] + '"';

                        if (val == Object.keys(this)[0]) {
                            field = field + ' selected';
                        }

                        // The field is multiple/select2 select, so we need to check if the value is in the array
                        if (className.indexOf('multiple') > -1 || className.indexOf('select2') > -1) {
                            if (val.includes(Object.keys(this)[0])) {
                                field = field + ' selected';
                            }
                        }

                        field = field + '>' + Object.values(this)[0] + '</option>';
                    });

                    field = field + '</select>';

                } else if (col.type == 'date') {
                    field = '<input type="text" class="form-control date" value="' + val + '">';
                } else if (col.type == 'number') {
                    field = '<input type="number" class="form-control" value="' + val + '">';
                } else {
                    field = '<input type="' + col.type + '" class="form-control" value="' + val + '">';
                }

                $('#column-search-modal .modal-body table').append('<tr>\
                    <td nowrap>\
                        <label class="col-form-label">' + col.title + ':</label>\
                    </td>\
                    <td width="100%">\
                        ' + field + '\
                    </td>\
                </tr>');
            }
        });
    },

    /**
     * Apply any filters that the user put in the modal
     */
    applyFilter: function() {
        var index = 0;

        $(abcsetup.datatables.search.columnSettings).each(function(key, col) {
            if (col.searchable) {
                var value = $('#column-search-modal .modal-body').find('input:not(.select2-search__field), select').eq(index).val();

                // Handle array values from select2
                if (Array.isArray(value)) {
                    value = value.join(',');
                }

                value = abcsetup.datatables.search.stripBadInput(value);

                abcsetup.datatables.search.dtTable.column(key).search(value, true, true);
                index++;
            }
        });

        if (abcsetup.datatables.search.dtTable.settings().init().serverSide) {
            abcsetup.blockUI(true);
        }

        abcsetup.datatables.search.dtTable.draw();
    },

    /**
     * Reset any filtering that has been applied
     */
    resetFilter: function()
    {
        if (abcsetup.datatables.search.dtTable.settings().init().serverSide) {
            abcsetup.blockUI(true);
        }

        abcsetup.datatables.search.dtTable.state.clear();
        abcsetup.datatables.search.dtTable.search('');
        abcsetup.datatables.search.dtTable.columns().search('').draw();
    },

    /**
     * Apply any filters specified in the request string
     */
    applyRequestFilters: function(table)
    {
        var dataTable = table.DataTable();
        var searchColParam = abcsetup.getUrlParameter('search_cols[]');
        var searchColVals = abcsetup.getUrlParameter('search_vals[]');

        // We have a search_cols in the request string
        if (searchColParam) {
            if (dataTable.settings().init().columns.length) {
                $(dataTable.settings().init().columns).each(function(key, col) {
                    if (col.searchable) {
                        var idx = searchColParam.indexOf(col.data);

                        if (idx !== -1) {
                            dataTable.column(key).search(searchColVals[idx], true, true);
                        }
                    }
                });
            }

            dataTable.draw();
        }
    },

    /**
     * Handle the draw back event from the table
     *
     * @param {*} table
     */
    drawBack: function(table)
    {
        // Highlight any searched values
        table.DataTable().on('draw', function () {
            var index = 1;
            var is_filtering = '';
            var global_search = table.DataTable().search();

            // Remove the search banner
            table.closest('.dataTables_wrapper')
                .find('.alert.table-filtering').remove();

            // Global search highlighting
            if (global_search) {
                is_filtering += global_search + ', ';
            }

            // Loop through each column and check for filters
            table.DataTable().columns().every(function() {
                if (this.search()) {
                    is_filtering += '<b>' + this.header().innerHTML + ':</b> ' + this.search() + ', ';
                }

                if (this.visible()) {
                    table.find("tr td:nth-child(" + (index) + ")").unhighlight();

                    // We have a search on the column or a global search
                    if (this.search() || global_search) {
                        var search = global_search ? this.search() + ' ' + global_search : this.search();

                        if (this.header().className.indexOf('multiple') > -1 || this.header().className.indexOf('select2') > -1) {
                            search = search ? search.trim().split(',') : null;
                        } else {
                            search = search ? search.trim().split(' ') : null;
                        }

                        table.find("tr td:nth-child(" + (index) + ")").highlight(search);
                    }

                    index ++;
                }
            });

            // Add the alert about the table being filtered
            if (is_filtering) {
                table.closest('.dataTables_wrapper')
                    .prepend('<div class="alert alert-info table-filtering alert-dismissible fade show">\
                        <i class="fas fa-search"></i> Searching for:\
                        ' + is_filtering.substring(0, is_filtering.length - 2) + '\
                        <button type="button" class="close reset-column-search" title="Reset Filters">\
                            <span aria-hidden="true">&times;</span>\
                        </button>\
                        </div>');
            }
        });
    },

    stripBadInput(value) {
        if (value.startsWith('*') || value.endsWith('*')) {
            value = value.slice(1);
            value = value.slice(0, -1);
        }

        if (value.includes('[') && !value.includes(']')) {
            value += ']';
        }

        if (value.includes(']') && !value.includes('[')) {
            value = '[' + value;
        }

        return value;
    }
}
